import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { IImage } from './models/IImage';


let imagesRaw: string = document.getElementById('root')?.innerText + "";
let parsedImages: IImage[] = [];
imagesRaw.split(";").forEach(img => {
  let split = img.split("|")
  if (split[0].trim() + "" !== "") {
    parsedImages.push({ url: split[0].trim(), desc: split[1] != null ? split[1].trim() : "" });
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App images={parsedImages} />
  </React.StrictMode>,
  document.getElementById('root')
);
